<template>
  <div class="wrap">
    <div class="partner">
      <div class="partnerTitle">合作伙伴</div>
      <div class="partnerEn">ECO-PARTNERS</div>
      <div class="partnerBox">
        <div v-for="(item, index) in arr" :key="index" class="partnerBoxItem">
          <div class="partnerBoxItemTitle">{{ item.title }}</div>
          <div class="partnerBoxItemPhotos">
            <img
              v-for="(child, index) in item.pcPhotos"
              :key="index"
              :src="child"
              alt=""
              class="partnerBoxItemPhotosImg"
            />
          </div>
        </div>
      </div>
    </div>
    <img src="https://p0.ssl.qhimg.com/t110b9a9301a1cbba443c1e6436.png" alt="" class="partnerImg" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps(['arr'])
const arr = props.arr || {}
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background-color: #f3f3f3;
  padding-bottom: 170px;
  // background-color: pink;
}

.partner {
  width: 90%;
  min-width: 1230px;
  margin: 0 auto;
  z-index: 10;
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    margin-top: 16px;
    margin-bottom: 110px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    display: inline-block;
  }
  &Box {
    // height: 800px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    border-radius: 32px;
    padding: 40px;
    &Item {
      display: flex;
      margin-bottom: 40px;
      &Title {
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 600;
        line-height: 48px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin-right: 40px;
        width: 165px;
        // width: 20%;
        // background-color: pink;
      }
      &Photos {
        width: 1351px;
        display: flex;
        flex-wrap: wrap;
        gap: 40px 18px;
        row-gap: 40px;
        &Img {
          width: 156px;
          // width: 11%;
          // background-color: green;
        }
      }
    }
    &Item:last-child {
      margin-bottom: 0;
    }
  }
  &Img {
    width: 374px;
    position: absolute;
    right: -77px;
    top: 0;
  }
}
</style>
